import clsx from 'clsx'
//import './title.scss'

type TitleProps = {
	children: React.ReactNode
	small?: boolean
	className?: string
}

const Title: React.FC<TitleProps> = ({ children, small, className }) => {
	const classes = clsx(
		'title',
		'title-servizi',
		{
			'title--default': !small,
			'title--smaller': small,
		},
		className
	)
	return <h2 className={classes}>{children}</h2>
}

export default Title
